import PropTypes from 'prop-types';

const PageConfigPropType = PropTypes.shape({
  accountId: PropTypes.string,
  accountBranded: PropTypes.bool,
  colourTheme: PropTypes.string,
  logoUrl: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  urls: PropTypes.shape(
    {
      url: PropTypes.string,
      loginUrl: PropTypes.string,
      registrationUrl: PropTypes.string,
    },
  ),
  pageConfiguration: PropTypes.shape({
    allowPasswordless: PropTypes.bool,
    title: PropTypes.string,
    introduction: PropTypes.string,
    oauthProviders: PropTypes.arrayOf(PropTypes.shape({
      provider: PropTypes.string,
      allow: PropTypes.bool,
      clientId: PropTypes.string,
      clientSecret: PropTypes.string,
    })),
    cancelSubscriptionConfiguration: PropTypes.shape({
      cancelButtonText: PropTypes.string,
      cancelMessage: PropTypes.string,
      displayWarningMessage: PropTypes.bool,
      warningMessage: PropTypes.string,
      redirectButtonText: PropTypes.string,
      redirectUrlPath: PropTypes.string,
    }),
    sections: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      order: PropTypes.number,
      items: PropTypes.arrayOf(PropTypes.shape({
        defaultValue: PropTypes.string,
        displayCondition: PropTypes.string,
        html: PropTypes.string,
        inputType: PropTypes.string,
        isDefault: PropTypes.bool,
        isRequired: PropTypes.bool,
        label: PropTypes.string,
        order: PropTypes.number,
        placeholder: PropTypes.string,
        slug: PropTypes.string,
      })),
    })),
  }),
  languagePack: PropTypes.shape({
    entries: PropTypes.shape,
  }),
});

export default PageConfigPropType;
